module.exports = __webpack_public_path__ + "img/T1C_rc_6.d57e6f53.png";